export class MEGConstants {
	public static readonly CONFIGURATION_URI: string = "/meg/configuration/";
}
